import { styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const TDCTOContainer = styled.div`
  background: ${(props) => (props?.propBackground ? props?.propBackground : '#1C2120')};
  padding: 24px 16px;
  @media (min-width: 768px) {
    padding: 48px 72px;
  }
`

export const TDCTOPrimaryHeading = styled.div`
  font-weight: 500;
  text-align: center;
  margin: auto;
  font-size: 32px;
  margin-bottom: 32px;
  color: ${(props) => (props?.propColor ? props?.propColor : '#fff')};
  @media (min-width: 768px) {
    margin-bottom: 32px;
    font-size: 40px;
  }
`

export const TDCTOSectionsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  color: #fff;
  flex-direction: column;
  max-width: 864px;
  margin: auto;
  @media (min-width: 768px) {
    gap: 80px;
    flex-direction: row;
  }
`

export const TDCTOPrimarySectionHeadingItem = styled.div`
  font-size: 16px;
  color: ${(props) => (props?.propColor ? props?.propColor : '#cad2fe')};
  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const TDCTOPrimarySectionDescriptionItem = styled.div`
  font-size: 12px;
  font-weight: 100;
  color: ${(props) => (props?.propColor ? props?.propColor : '#fff')};
  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const TDCTOSecondaryItemContainer = muiStyled('div')(
  ({ theme, altColor }) => `
border-radius: 20px;
padding: 8px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
margin-bottom: 8px;
width: 220px;
transition: all 300ms;
border: 2px solid transparent;
background: ${altColor ? 'rgb(255 255 255)' : '#cad2fe'};
${altColor ? 'border: 2px solid rgb(202, 210, 254);' : 'border: 2px solid transparent;'}

.primary-text {
  ${'' /* color: #fff; */}
  text-align: center;
  color: ${altColor ? '#020301' : '#7681bb'};
  font-weight: 700;
  font-size: 38px;
  transition: all 300ms;
  line-height: 44px;
}
.secondary-text {
  color: #000;
  text-align: center;
  font-size: 10px;
}

&:hover {
  background: ${altColor ? '#cad2fe' : 'rgb(255 255 255)'};
  .primary-text {
    color: ${altColor ? '#020301' : '#7681bb'};
  }
}
@media (min-width: 768px) {
  .primary-text {
    font-weight: 700;
    font-size: 62px;
    line-height: 68px;
  }
  .secondary-text {
    font-size: 15px;
  }
}
`,
)

export const PrimaryDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`
